import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1bdde28b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "pricing-summary-container",
    tabindex: "0"
};
const _hoisted_2 = { class: "summary-container" };
const _hoisted_3 = { class: "header display-name-input-styling viewer" };
const _hoisted_4 = {
    class: "discount-container",
    "data-external": "discount-container-2"
};
const _hoisted_5 = { class: "discount display-name-input-styling viewer" };
const _hoisted_6 = {
    class: "tax-container",
    "data-external": "tax-container-2"
};
const _hoisted_7 = { class: "tax display-name-input-styling viewer" };
const _hoisted_8 = {
    class: "total-container",
    "data-external": "total-container-2"
};
const _hoisted_9 = { class: "total display-name-input-styling viewer" };
const _hoisted_10 = { class: "total-value" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.summaryValues.displayName), 1),
            _withDirectives(_createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.summaryValues.discount.displayName), 1),
                _createElementVNode("div", {
                    class: _normalizeClass(["discount-value pointer", { empty: _ctx.getTotalDiscountIsEmpty(_ctx.summaryValues) }])
                }, _toDisplayString(_ctx.getTotalDiscountValue), 3)
            ], 512), [
                [_vShow, _ctx.summaryDiscountEnabled]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.summaryValues.tax.displayName), 1),
                _createElementVNode("div", {
                    class: _normalizeClass(["tax-value pointer", { empty: _ctx.getTotalDiscountIsEmpty(_ctx.summaryValues) }])
                }, _toDisplayString(_ctx.getTotalTaxValue), 3)
            ], 512), [
                [_vShow, _ctx.summaryTaxEnabled]
            ]),
            _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.summaryPriceDisplayName), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.currencyFormat(_ctx.getTotalPriceValue(_ctx.summaryValues), _ctx.currencySettings)), 1)
            ])
        ])
    ]));
}
